var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTv = function SvgIconTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74 12.001h4.047L6.26 7.827l-.522 1.565zM12 9.787 7.826 5.739H12z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.033z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.261V.001h-.002C5.372 0 0 5.372 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.787L8.474 6.26z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.565a12.06 12.06 0 0 0-4.506 4.506v5.93h3.13V4.695H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.524 7.738 6.261H6.262L12 12z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.097 19.825.26.797h.837l-.678.493.26.797-.679-.492-.678.492.26-.797-.679-.493h.838zM19.773 14.61l.259.796h.838l-.678.493.26.797-.679-.493-.678.493.259-.797-.678-.493h.838zM21.445 6.782l.259.798h.838l-.678.492.259.797-.678-.492-.678.492.259-.797-.678-.492h.838zM21.86 12.521l.259.797h.838l-.678.493.259.797-.678-.492-.678.492.259-.797-.678-.493h.838zM14.299 17.951l.747.38.593-.592-.131.828.746.38-.828.132-.13.828-.381-.747-.828.13.593-.592zM14.299 14.821l.747.38.593-.592-.131.828.746.38-.828.132-.13.827-.381-.746-.828.13.593-.592zM16.908 16.827l.747.38.593-.592-.131.828.747.38-.828.131-.131.828-.38-.747-.829.132.593-.593zM16.908 10.125l.747.38.593-.592-.131.827.747.38-.828.132-.131.828-.38-.747-.829.131.593-.592zM19.437 10.044l.747.38.592-.592-.13.828.746.38-.828.132-.131.828-.38-.747-.828.13.592-.592z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTv;